import * as React from "react";
import { Utils } from "../../Utils";

/**
 * Gets a localized string by ID
 *
 * @param id - the string ID
 * @returns the localized string
 */
export const getLocalizedString = (id: string | undefined): string => {
  if (id) {
    if (Utils.hasKey(ClientStrings, id)) {
      return ClientStrings[id];
    } else if (Utils.hasKey(WebsiteStrings, id)) {
      return WebsiteStrings[id];
    }
  }

  return id ?? "";
};

/**
 * Properties for LocalizedText component
 */
export interface ILocalizedTextProps {
  /**
   * The ID of the string. Should exist in either the WebSiteStrings or ClientStrings object.
   */
  stringId: string;
}

/**
 * A component for displaying localized text
 *
 * @param props - the component props
 * @returns the markup
 */
export const LocalizedText: React.FC<ILocalizedTextProps> = (props) => {
  return <>{getLocalizedString(props.stringId)}</>;
};
